import React from 'react';
import {useSelector, useDispatch} from 'react-redux';

import TextField from '@material-ui/core/TextField';

import {setCampaignFormField} from '../../../../redux/actions/campaigns';


const CampaignNameInput = () => {
	const dispatch = useDispatch();
	const {campaign_name} = useSelector(state => state.campaigns.campaign_form);

	const handleChange = (event) => {
		const value = event.target.value;

		dispatch(setCampaignFormField('campaign_name', value));
	}

	return (
		<TextField autoFocus color="primary" label="Campaign Name" variant="outlined" onChange={handleChange} value={campaign_name} fullWidth />
	)
}

export default CampaignNameInput;